import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * ConsultantAdviserContent のスタイル
 */
export const consultantAdviserContentStyle = tv({
    slots: {
        avatar: [],
        base: ['flex flex-col gap-y-16'],
        bottomContent: ['flex items-center'],
        buttonWrap: ['flex items-center gap-8 z-0'],
        calendarButton: ['block'],
        descriptionBox: [
            textStyle({ color: 'textGray', size: 'xs' }),
            'text-center',
        ],
        name: [],
        phone: ['mt-4'],
        userContent: ['flex items-center gap-8'],
    },
    variants: {
        isLarge: {
            false: {
                avatar: ['w-[44px] h-[44px] text-[44px] leading-none'],
                bottomContent: ['justify-between'],
            },
            true: {
                avatar: ['w-[60px] h-[60px] text-[60px] leading-none'],
                bottomContent: ['justify-center gap-x-32'],
                name: ['!leading-none'],
            },
        },
    },
});
